import React from 'react';

import { flagStyles } from '../settings';

const SvgTJ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5184px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTJ;
